import { api, localDateTime } from './api';
import { captureSchedule } from './voiceSchedule';
import { flagNoteForReview, rememberVoiceDraft, clearVoiceDraft } from './noteReview';

export function scheduleCorrection(note, schedule) {
  if (!schedule?.enforce) return {};
  const patch = {};
  const dateOnly = !schedule.value ? schedule.date || null : null;
  if ((note.scheduled_at || null) !== schedule.value) patch.scheduled_at = schedule.value;
  if ((note.detected_date || null) !== dateOnly) patch.detected_date = dateOnly;
  return patch;
}

// Typed saves get the same calendar placement, but do not inherit automatic
// voice splitting or new category rules. Still one existing backend record.
export async function createTypedSave(text, options = {}, client = api) {
  const reference = new Date(), schedule = captureSchedule(text, reference);
  let note = await client.create(text, 'typed', { ...options, clientNow: localDateTime(reference) });
  const patch = scheduleCorrection(note, schedule);
  if (note.text !== text) patch.text = text;
  if (Object.keys(patch).length) {
    try { note = await client.update(note.id, patch, options); clearVoiceDraft(note); }
    catch { if (note.text !== text) rememberVoiceDraft(note, text); flagNoteForReview(note); return note; }
  }
  if (schedule.uncertain) flagNoteForReview(note);
  return note;
}